import { withAsyncErrorHandler } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/error-util';
import { formatCovers, getCover } from '@monorepo/shared/src/util/book-util';
import fetchAsText from 'util/fetch-as-text-util';

const fetchBookCoversHtml = async (books) => {
  const bookCoversHtmlText = await withAsyncErrorHandler(() =>
    Promise.allSettled(books.map((book) => fetchAsText(getCover(book).src)))
  );
  return formatCovers(bookCoversHtmlText, books);
};

export default fetchBookCoversHtml;
